import React, { Suspense, memo, useCallback, useEffect } from "react";

import { VERSION } from "../../settings";
import PageLoading from "../Shared/PageLoading";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PermissionRoute from "components/Shared/PermissionRoute";

const ApplicationsPage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ApplicationsIndex" */
      /* webpackPrefetch: true */
      "./Applications"
    )
);

const NewPasswordPage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminCenter" */
      /* webpackPrefetch: true */
      "./Public/NewPassword"
    )
);

const Pages = memo(() => {
  const RenderEmpty = useCallback(() => <div />, []);
  const RenderRedirect = useCallback(() => <Navigate to="/" />, []);

  useEffect(() => {
    console.info(`[[[ RUNNING VERSION ${VERSION} ]]]`);
  }, []);

  return (
    <Suspense fallback={<PageLoading />}>
      <BrowserRouter>
        <Routes>
          <Route path="/new-password" element={<NewPasswordPage />} />
          <Route
            path="/applications/*"
            element={
              <PermissionRoute>
                <ApplicationsPage />
              </PermissionRoute>
            }
          />
          <Route
            path="*"
            element={
              <PermissionRoute>
                <ApplicationsPage />
              </PermissionRoute>
            }
          />
          <Route path="/reload" element={<RenderEmpty />} />
          <Route path="*" element={<RenderRedirect />} />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
});

export default Pages;
